module.exports = __webpack_public_path__ + "img/camera.f5090437.svg";